import {useRouter} from 'vue-router';
import Network from "@/common/network";

const network = {
  unauthorized: async (response, next) => {
    const router = useRouter();
    if (Network.unauthorized.code === response.data.code) {
      await router.push({name: 'Login'});
      return;
    }
    next && next();
  },
  useResponseChain: () => {
    const middlewares = [];
    const chain = {
      use: middleware => {
        if (Array.isArray(middleware))
          middlewares.push(...middleware);
        else
          middlewares.push(middleware);
        return chain;
      },
      run: response => {
        const reversed = [...middlewares].reverse();
        const func = reversed.reduce((acc, cur) => {
          if (acc === null)
            return response => cur(response, null);
          return response => cur(response, () => acc(response));
        }, null);
        func(response);
      },
    };
    return chain;
  },
};

export default {
  install: (app, options) => {
    app.provide('network', network);
  }
};
